/**
 * @generated SignedSource<<0ea15696312b442f7b547eb23e7f700c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priorityField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly priority: {
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "priorityField_updateWorkItemAllFieldTypesActionRenderer";
};
export type priorityField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: priorityField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"priorityField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "priorityField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "6938ec4d6a6506763265af6b3316604c";

export default node;
